var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleCheckRegular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_275_9524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4746 13.2734C10.0488 13.6992 9.35352 13.6992 8.92773 13.2734L6.42773 10.7734C6.00195 10.3477 6.00195 9.65234 6.42773 9.22656C6.85352 8.80078 7.54883 8.80078 7.97461 9.22656L9.70117 10.9531L13.9277 6.72656C14.3535 6.30078 15.0488 6.30078 15.4746 6.72656C15.9004 7.15234 15.9004 7.84766 15.4746 8.27344L10.4746 13.2734ZM20.9512 10C20.9512 15.5234 16.4746 20 10.9512 20C5.42773 20 0.951172 15.5234 0.951172 10C0.951172 4.47656 5.42773 0 10.9512 0C16.4746 0 20.9512 4.47656 20.9512 10ZM10.9512 1.875C6.46289 1.875 2.82617 5.51172 2.82617 10C2.82617 14.4883 6.46289 18.125 10.9512 18.125C15.4395 18.125 19.0762 14.4883 19.0762 10C19.0762 5.51172 15.4395 1.875 10.9512 1.875Z",
    fill: "#078177"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_275_9524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.951172)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckRegular);
export default __webpack_public_path__ + "static/media/circle-check-regular.3ca1ec619ce7749dd3fe8edf3dabb785.svg";
export { ForwardRef as ReactComponent };